<script setup>
import { ref,onMounted } from 'vue'

// props
const props = defineProps({
  modelValue: {
    type: [String,Number],
    default: null,
  },
  id: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
    validator(value, props) {
      return ['text', 'number', 'password', 'email', 'tel'].includes(value)
    }
  },
  classNm:{
    type : String,
    default : 'form-control'
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  onlyNumber: {
    type: Boolean,
    default: false,
  },
  phoneNumber: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: Number,
  },
  focusYn :{
    type:Boolean,
    default : false
  },
  onlyPlusNumber :{
    type:Boolean,
    default:false
  }
})
onMounted(()=>{
  if(props.focusYn){
    input.value.focus()
  }
})
// data - ref
const input = ref(null)

// expose
defineExpose({ input })

// emit
const emit = defineEmits(['update:modelValue', 'inputClick', 'inputKeyupEnter', 'inputBlur', 'inputFocusout', 'inputKeyup'])

// methods
function emitValue(event) {
  let value = event.target.value;

  // 숫자만 허용
  if (props.onlyNumber) {
    value = value.replace(/[^0-9]/g, '');
  }

  // 전화번호 형식 (숫자와 "-"만 허용)
  if (props.phoneNumber) {
    value = value.replace(/[^0-9/-]\s+/g, '');
  }

  if (props.onlyPlusNumber &&value < 0) {
    value = 0;
  }

  emit('update:modelValue', value);
}
</script>

<template>
  <input
    ref="input"
    :class="classNm"
    :placeholder="placeholder"
    :id="id"
    :type="type"
    :maxlength="maxlength"
    :value="modelValue"
    :disabled="disabled"
    :readonly="readonly"
    @input="emitValue"
    @click="emit('inputClick', $event)"
    @keyup.enter="emit('inputKeyupEnter', $event)"
    @keyup="emit('inputKeyup', $event)"
    @blur="emit('inputBlur', $event)"
    @focusout="emit('inputFocusout', $event)"
  >
</template>